$(document).ready(() => {
    let $body = $('body')

    $body.on('click', '.about-modal-btn', function () {
        $("#about-modal").addClass('active')
    })

    $('#about-modal .modal-close').click(closeAboutModal)

    $(document).keyup(function(e) {
        if (e.which == 27) {
            closeAboutModal(e)
        }
    })

    $('#about-modal').click(function(e) {
        if($(e.target).hasClass('modal')) {
            closeAboutModal(e)
        }
    })
})

const closeAboutModal = function(e) {
    e.preventDefault()
    $("#about-modal").removeClass('active')
}
